import { FC, useEffect, useRef } from 'react';

import { BugoKakaoShareContent } from '@service/bugo/utils/bugoMessage.util';
import { Icon } from '@shared/components/icons';

type Props = {
  kakaoContent: BugoKakaoShareContent;
  shareCountUpdateFunc?: () => void;
};
declare global {
  interface Window {
    Kakao: any;
  }
}
const KakaoShareButton: FC<Props> = ({ kakaoContent, shareCountUpdateFunc }: Props) => {
  const { ShareKakao } = Icon();
  const kakao = window.Kakao;
  const isEventListenerAdded = useRef(false);

  useEffect(() => {
    if (kakao) {
      if (!kakao.isInitialized()) {
        kakao.init(process.env.REACT_APP_KAKAO_SHARE_JAVASCRIPT_KEY);
      }
      kakao.Link.createCustomButton({
        container: '#kakaotalk-sharing-btn',
        templateId: Number(process.env.REACT_APP_KAKAO_SHARE_BUGO_BTN_ID),
        templateArgs: {
          header: kakaoContent.header,
          deathDate: kakaoContent.deathDate,
          deceasedName: kakaoContent.deceasedName,
          bugoTerm: kakaoContent.bugoTerm,
          bugoId: kakaoContent.bugoId,
        },
      });
    }
  }, [kakao, kakaoContent]);

  useEffect(() => {
    if (!isEventListenerAdded.current && shareCountUpdateFunc) {
      const shareBtn = document.querySelector('.share-btn');
      if (shareBtn) {
        shareBtn.addEventListener('click', shareCountUpdateFunc);
        isEventListenerAdded.current = true;
      }
    }

    return () => {
      if (isEventListenerAdded.current && shareCountUpdateFunc) {
        const shareBtn = document.querySelector('.share-btn');
        if (shareBtn) {
          shareBtn.removeEventListener('click', shareCountUpdateFunc);
          isEventListenerAdded.current = false;
        }
      }
    };
  }, [shareCountUpdateFunc]);

  return (
    <button className="share-btn" id="kakaotalk-sharing-btn">
      <ShareKakao />
    </button>
  );
};

export default KakaoShareButton;
